import React from "react";
import { Box } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

// Returns the date string of the earliest upcoming session, or null if none exist.
function nextUpcomingSessionDate(sessions) {
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = sessions
    .filter((s) => s.sessionDate && s.sessionDate >= today)
    .sort((a, b) => (a.sessionDate < b.sessionDate ? -1 : a.sessionDate > b.sessionDate ? 1 : 0));
  return upcoming.length > 0 ? upcoming[0].sessionDate : null;
}

export default function SessionCalendarView({ sessions = [], T, onSelectSession }) {
  const events = sessions
    .filter((s) => s.sessionDate)
    .map((s) => ({
      id: String(s.id),
      title: `Session ${s.sessionNumber ?? s.name ?? s.id}${s.location ? " · " + s.location : ""}`,
      start: s.startTime ? `${s.sessionDate}T${s.startTime}` : s.sessionDate,
      end: s.endTime ? `${s.sessionDate}T${s.endTime}` : undefined,
      color: s.sessionType === "VIRTUAL" ? T.purple : T.primary,
      extendedProps: { session: s },
    }));

  const initialDate = nextUpcomingSessionDate(sessions) || undefined;

  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border: `1px solid ${T.line}`,
        borderRadius: "16px",
        boxShadow: "0 1px 0 rgba(20,24,40,.04),0 1px 3px rgba(20,24,40,.06)",
        overflow: "hidden",
        p: "16px 18px 20px",
        "& .fc": { fontFamily: "inherit" },
        "& .fc-daygrid-day-number": { fontSize: "12.5px", fontWeight: 700, color: T.ink2 },
        "& .fc-col-header-cell-cushion": {
          fontSize: "11px", fontWeight: 700, textTransform: "uppercase",
          letterSpacing: ".06em", color: T.ink3,
        },
        "& .fc-event": {
          borderRadius: "6px", fontSize: "11px", fontWeight: 700,
          borderWidth: 0, cursor: "pointer",
        },
        "& .fc-toolbar-title": { fontSize: "16px", fontWeight: 700, color: T.ink, fontFamily: "var(--font-display)" },
        "& .fc-theme-standard td, & .fc-theme-standard th": { borderColor: T.line2 },
        "& .fc-scrollgrid": { borderColor: T.line, borderRadius: "12px", overflow: "hidden" },
        "& .fc-button": {
          bgcolor: T.surface, color: T.ink, borderColor: T.line, textTransform: "capitalize",
          boxShadow: "none",
        },
        "& .fc-button-primary:not(:disabled).fc-button-active": {
          backgroundColor: T.primary, borderColor: T.primary,
        },
      }}
    >
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        initialDate={initialDate}
        events={events}
        height="auto"
        headerToolbar={{ left: "prev,next today", center: "title", right: "" }}
        eventClick={(info) => {
          const session = info.event.extendedProps.session;
          if (session && onSelectSession) onSelectSession(session);
        }}
      />
    </Box>
  );
}
